<app-section-header
    itemsName="access"
    [totalItems]="peopleListBLoc.value()?.totalItems ?? 0"
    [(searchValue)]="searchValue"
    (search)="onSearch($event)">
    <app-button
        [disabled]="!hasAddAccessPermissions"
        [icon]="['fas', 'add']"
        [label]="'add' | transloco"
        [tooltip]="!hasAddAccessPermissions ? ('insufficientPermissions' | transloco) : undefined"
        [type]="ButtonType.PRIMARY"
        (onClick)="openEditAccessModal()" />
</app-section-header>
<div class="overflow-y-auto">
    @if (projectPeople().length) {
        @if (!isLoading()) {
            <div class="mt-4">
                <app-custom-table
                    [columns]="tableColumns"
                    (sortEvent)="onSort($event)">
                    @for (person of projectPeople(); track person.id) {
                        <tr [class.details-opened]="false">
                            @for (column of tableColumns.slice(0, -1); track column.key) {
                                <td>{{ person[column.key] }}</td>
                            }
                            <td>
                                @if (rolesById() && person.role && rolesById()![person.role]) {
                                    {{ rolesById()![person.role].name }}
                                } @else {
                                    -
                                }
                            </td>
                        </tr>
                    }
                </app-custom-table>
            </div>
        } @else {
            <app-loading />
        }
        <div class="flex justify-start my-4">
            <app-paginator
                #paginator
                [take]="peopleListBLoc.value()?.take ?? 10"
                [totalItems]="peopleListBLoc.value()?.totalItems ?? 0"
                (onPageChange)="onPageChange($event)" />
        </div>
    } @else {
        <app-no-data-to-display iconSize="3x" />
    }
</div>
